import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import DateInput from '../../atoms/DateInput/DateInput';
import ArrowRight from '../../../assets/arrow-right';

interface DateRangeInputsProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateClick: () => void;
  onEndDateClick: () => void;
  disabled?: boolean;
  dateFormat?: string;
  firstPlaceholder?: string;
  secondPlaceholder?: string;
}

const DateRangeInputs: React.FC<DateRangeInputsProps> = ({
  startDate,
  endDate,
  onStartDateClick,
  onEndDateClick,
  disabled = false,
  dateFormat,
  firstPlaceholder = 'startDate',
  secondPlaceholder = 'endDate',
}) => {
  const { t: translate } = useTranslation();

  return (
    <DateRangeContainer>
      <DateInputWrapper>
        <DateInput
          date={startDate}
          onClick={onStartDateClick}
          placeholder={translate(firstPlaceholder)}
          label={translate(secondPlaceholder)}
          disabled={disabled}
          id="start-date-input"
          dateFormat={dateFormat}
        />
      </DateInputWrapper>
      <IconWrapper>
        <ArrowRight />
      </IconWrapper>
      <DateInputWrapper>
        <DateInput
          date={endDate}
          onClick={onEndDateClick}
          placeholder={translate(secondPlaceholder)}
          label={translate(firstPlaceholder)}
          disabled={disabled}
          id="end-date-input"
          dateFormat={dateFormat}
        />
      </DateInputWrapper>
    </DateRangeContainer>
  );
};

const DateRangeContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  align-items: center;
`;

const DateInputWrapper = styled.div`
  flex: 1;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default DateRangeInputs;
